import Vue from 'vue';
import Vuex from 'vuex';
import { PaginationPlugin } from 'vuex-pagination';

Vue.use(Vuex);
Vue.use(PaginationPlugin);
